export enum RibbonType {
  RECOMMENDED = 'Recommended',
  SPONSORED = 'Sponsored',
  NEW_FREELANCER = 'New Freelancer',
  HIGHLIGHTED = 'Highlighted',
  DYNAMIC = 'Dynamic',
}
